import React from 'react'
import { Stack, Typography } from '@mui/material'
import DynamicPriceIcon from 'src/Libs/e-mobility/icons/DynamicPriceIcon'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'

interface PricingInfoProps {
  totalCostKWh: number
  dynamicPrice?: boolean
  className?: string
}

/**
 * Component for displaying pricing information inside charging sessions details modal.
 * @param totalCostKWh - sessions cost as number
 * @param dynamicPrice - optional boolean
 * @param className - custom classes if needed
 */
export const PricingInfo: React.VFC<PricingInfoProps> = ({ className, totalCostKWh, dynamicPrice = false }) => {
  const { t, selectedAppLanguage } = useCustomTranslation()
  const formattedCost = new Intl.NumberFormat(selectedAppLanguage, { style: 'currency', currency: 'EUR' }).format(totalCostKWh)

  return (
    <Stack direction={'row'} gap={2} alignItems={'center'} className={className}>
      {dynamicPrice && (
        <OptionalTooltipWrapper titleKey="emobility.chargingSession.dynamic-price-tooltip" placement="top">
          <DynamicPriceIcon />
        </OptionalTooltipWrapper>
      )}
      <Typography variant="body2">{formattedCost}</Typography>
      {dynamicPrice && <Typography variant="body2">{t('emobility.chargingSession.dynamic')}</Typography>}
    </Stack>
  )
}
